package com.steamstreet.dates

import kotlinx.datetime.LocalTime

public typealias KLocalTime = LocalTime

public fun LocalTime.toISO8601(): String {
    return "${hour.pad(2)}:${minute.pad(2)}:${second.pad(2)}".let {
        if (nanosecond > 0) {
            "$it.$nanosecond"
        } else {
            it
        }
    }
}

/**
 * Format a time with the given pattern.
 */
public fun LocalTime.format(pattern: String): String {
    val groups = mutableListOf<String>()

    var lastChar = ' '
    var currentGroup = ""

    pattern.forEach {
        if (it != lastChar) {
            if (currentGroup.isNotEmpty()) {
                groups += currentGroup
                currentGroup = ""
            }
        }
        currentGroup += it
        lastChar = it
    }
    if (currentGroup.isNotEmpty()) {
        groups += currentGroup
    }

    return groups.map { group ->
        when (group[0]) {
            // Clock hour of AM/PM runs 1..12: midnight and noon are both 12, not 0.
            'h' -> ((hour % 12).let { if (it == 0) 12 else it }.toString()).padStart(group.length, '0')
            'H' -> hour.toString().padStart(group.length, '0')
            'm' -> minute.toString().padStart(group.length, '0')
            's' -> second.toString().padStart(group.length, '0')
            'a' -> if (hour >= 12) "PM" else "AM"
            else -> group
        }
    }.joinToString("")
}

public fun Int.pad(size: Int): String {
    var s = "$this"
    while (s.length < size) {
        s = "0$s"
    }
    return s
}